// extracted by mini-css-extract-plugin
export default {"app__wrapper":"app_app__wrapper__c8eaC","appHeader":"app_appHeader__+ixdY","content__wrapper":"app_content__wrapper__1vnAK","emptyText":"app_emptyText__0AG42"};